import { DOMAIN } from './Consents.constants';
import get from 'lodash/get';

export const getStore = state => get(state, DOMAIN) || [];

export const getResults = state => getStore(state).results || [];
export const getResultCount = state => getStore(state).resultCount || 0;
export const getError = state => getStore(state).error;
export const isLoading = state => getStore(state).loading;
